import { isPlatformBrowser } from '@angular/common';
import { EnvironmentProviders, inject, makeEnvironmentProviders, PLATFORM_ID, provideEnvironmentInitializer } from '@angular/core';

import { jam } from '@jam.dev/sdk';
import { Store } from '@ngrx/store';

import { AbilityStore } from '@app/auth/ability/ability.store';
import { selectUser } from '@app/auth/store/selectors/user.selectors';

export function provideJam(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideEnvironmentInitializer(() => {
      if (!isPlatformBrowser(inject(PLATFORM_ID))) {
        return;
      }

      const user = inject(Store).selectSignal(selectUser);
      const abilityStore = inject(AbilityStore);
      jam.metadata(() => {
        const current = user();
        const ability = abilityStore.abilityResourceValue();
        return {
          ...(current ? { user: current } : {}),
          ...(ability ? { ability } : {}),
        } as jam.SerializableObject;
      });
    }),
  ]);
}
